const now = new Date();
const hour = now.getUTCHours();
const dot = document.getElementById("live-chat-indicator");

if (hour > 14 && hour < 21) {
    console.log("LIVE")
    console.log(dot)
    dot.innerHTML = "HELLO WORLD"
} else {
    console.log("UNLIVE")
    console.log(dot)
    dot.innerHTML = "HELLO WORLD"
}



// remve script
// change element containing id